
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="modal-title">
    <div [formGroup]="modalForm">
      <h3 class="green decoration mb-4">
        <span *ngIf="showTable">
          Añadir producto
        </span>
        <span *ngIf="!showTable">
          Editar producto
        </span>
      </h3>
      <p class="mb-2" *ngIf="showTable"> <strong *ngIf="actualRow?.product_name">Producto seleccionado: </strong> {{ actualRow?.product_name || 'Escoja el producto o servicio que desea agregar al acuerdo comercial' }}</p>
      <div class="filters-modal-wrapper" [class.mb-2]="!showTable">
        <div class="form-wrapper mb-3">
          <span>Tipo de precio</span>
          <mat-select (click)="setFocus('matInput1')" formControlName="price_type" placeholder="Seleccione una opción" (selectionChange)="filterName($event)">
            <ng-container *ngIf="providerTypes; else elseProviderTypes">
              <div class="filter_option">
                <input placeholder="Buscar..." [(ngModel)]="filterTerm" class="!outline-none"
                  [ngModelOptions]="{standalone: true}" id="matInput1">
              </div>
              <mat-option value="">Seleccione una opción</mat-option>
              <mat-option *ngFor="let providerType of providerTypes | filter: filterTerm; let i = index" [value]="providerType.value">{{ providerType.name }}</mat-option>
            </ng-container>
            <ng-template #elseProviderTypes>
              <mat-option value="">No se encontraron resultados...</mat-option>
            </ng-template>
          </mat-select>
        </div>
        <div class="form-wrapper mb-3">
          <span>Precio unitario</span>
          <div class="flex w-full items-center">
            <input type="number" formControlName="base_price" placeholder="Ej: 2.0">
            <div *ngIf="modalForm.get('price_type').value == 'percentage'" class="font-bold text-2xl pl-1">%</div>
          </div>
        </div>
        <div class="form-wrapper mb-3">
          <span>Precio prueba</span>
          <div class="flex w-full items-center">
            <input type="number" formControlName="trial_price" placeholder="Ej: 1.8">
            <div *ngIf="modalForm.get('price_type').value == 'percentage'" class="font-bold text-2xl pl-1">%</div>
          </div>
        </div>
        <div class="form-wrapper mb-3">
          <span>Inicio de prueba</span>
          <input type="date" formControlName="trial_start">
        </div>
        <div class="form-wrapper mb-3">
          <span>Final de prueba</span>
          <input type="date" formControlName="trial_end_cap">
        </div>
        <div class="form-wrapper mb-3">
          <span>Divisa</span>
          <input type="text" formControlName="badge" [attr.disabled]="true">
        </div>
        <div class="form-wrapper mb-3" *ngIf="this.modalForm.get('price_type').value === 'credit'">
          <span>Tiempo</span>
          <input type="text" formControlName="time" placeholder="2" oninput="this.value = this.value.replace(/[^0-9]/g, '');">
        </div>
        <div class="form-wrapper mb-3" *ngIf="this.modalForm.get('price_type').value === 'quantity'">
          <span>Cantidad</span>
          <input type="text" formControlName="quantity" placeholder="2" oninput="this.value = this.value.replace(/[^0-9]/g, '');">
        </div>
      </div>
    </div>
  </div>
  <div class="modal-inner !py-0">
    <app-custom-table *ngIf="showTable" [functionalities]="['selectable', 'modal']" (eventSendRow)="setValuestoForm($event)" [displayedColumns]="displayedColumns" [data]="dataSource" [tableTitle]="'Últimos productos registrados'"></app-custom-table>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button>
        <button mat-button type="button" (click)="addComertialAgreementProduct()" class="btn btn-primary big" *ngIf="showTable">Agregar</button>
        <button mat-button type="button" (click)="editComertialAgreementProduct()" class="btn btn-primary big" *ngIf="!showTable">Guardar</button>
  </div>
</div>
